define('model/primary.reviewer.unit.assignment.model',['require','exports','module','fukit'],function(require, exports, module) {
    //prettier-ignore
    var BaseModel = require('fukit').BaseModel;

    var PrimaryReviewrUnitReportModel = BaseModel.extend({
        radioRequests: {
            'models PrimaryReviewrUnitReportModel': '@constructor',
        },

        urlRoot: '/api/v2/coi/export/fileLink/primaryreviewerslist',
    });

    module.exports = PrimaryReviewrUnitReportModel;
});


